// src/redux/slices/authSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ApiBaseUrl, submitBidByProfessional } from "../../Utils/Constants";
import { showToast } from "../../Helper/Toast";

export const hitSubmitBidApi = createAsyncThunk("hitSubmitBidApi", async (payload) => {
  try {
    const config = {
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        Authorization: `${localStorage.getItem("professionalToken")}`,
      },
    };
    const url = ApiBaseUrl + submitBidByProfessional;
    const response = await axios.post(url, payload, config);
    return response.data;
  } catch (error) {
    showToast(error.response.data.message, "error");
    throw error.response.data;
  }
});

const SubmitBidSlice = createSlice({
  name: "submitBidReducer",
  initialState: {
    isLoading: false,
    data: null,
  },
  reducers: {
    clearhitSubmitBidData: (state) => {
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(hitSubmitBidApi.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(hitSubmitBidApi.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(hitSubmitBidApi.rejected, (state) => {
        state.isError = false;
      });
  },
});

export const { clearhitSubmitBidData } = SubmitBidSlice.actions;
export default SubmitBidSlice.reducer;
